
import type { ProjectOps } from '@mimir/client-common/fileSync/projectOps';
import type { AdobePanelContext, ElectronContext } from '@mimir/common/context/applicationContext';
import type { PremiereProjectItemReference } from '@mimir/primitive/premiere/premiereReference';
import type { Logger } from '@mimir/common/types/logger';
import { exceptionToString } from '@mimir/common/util/exception';

export class DefaultProjectOps implements ProjectOps {

  constructor(private adobeContext: AdobePanelContext | ElectronContext, private logger: Logger) {}


  async setMimirItemIdForMediaPath(filePathForScript: string | null | undefined, itemId: string, itemRef: PremiereProjectItemReference): Promise<void> {
    const cepb = this.adobeContext.cepBridgeClient;
    await cepb.call('updateProjectItem', itemRef, {
      meta: {
        'Mimir.Item.Id': itemId,
      }
    }).catch((ex: unknown) => this.logger.error(`setMimirItemIdForMediaPath: ${exceptionToString(ex)}`));
  }

}
